import React from 'react'

import CustomImage from '../images/image'

const PlayButton = ({ onClick, className }) => (
  <button className={`play-button ${className}`} onClick={onClick}>
    <CustomImage
      className="unselectable"
      src="/icons/play.svg"
      alt="play icon"
      layout="fill"
    />
  </button>
)

export default PlayButton
